module.exports = __webpack_public_path__ + "img/girl selection.621f3d1d.png";